var map = {
	"./de.json": [
		1895,
		75
	],
	"./de_CH.json": [
		1896,
		76
	],
	"./de_DE.json": [
		1897,
		77
	],
	"./en.json": [
		664
	],
	"./en_CA.json": [
		1898,
		6
	],
	"./en_CH.json": [
		1855,
		3
	],
	"./en_GB.json": [
		1899,
		1
	],
	"./en_ZA.json": [
		1856,
		3
	],
	"./fr.json": [
		1900,
		78
	],
	"./fr_CA.json": [
		1901,
		1
	],
	"./fr_CH.json": [
		1902,
		1
	],
	"./it.json": [
		1903,
		79
	],
	"./it_CH.json": [
		1904,
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 776;
module.exports = webpackAsyncContext;